import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { api, subscriptionAPI } from 'services/api';

export function configureAppStore() {
  const store = configureStore({
    reducer: {
      [api.reducerPath]: api.reducer,
      [subscriptionAPI.reducerPath]: subscriptionAPI.reducer,
    },
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat([
        api.middleware,
        subscriptionAPI.middleware,
      ]),
    devTools: process.env.NODE_ENV !== 'production',
  });

  setupListeners(store.dispatch);

  return store;
}
